import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { EchantillonageService } from 'src/app/services/echantillonage.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ModerationService } from 'src/app/services/moderation.service';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';

@Component({
  selector: 'app-complexite',
  templateUrl: './complexite.component.html',
  styleUrls: ['./complexite.component.css']
})
export class ComplexiteComponent implements OnInit {

  tableauCols : any[] = [
    {field: 'num_point_accueil', header: 'Num point d\'accueil'},
    {field: 'id_responsable', header: 'Opérateur'},
    {field: 'id_complexite', header: 'Complexité'},
  ];

  liste : any[] = [];


  /**
   * Filtres multiselect
   */
  typeFilter : SelectItem[] = [
    {label : 'INITIALE', value : 'INITIALE' },
    {label : 'R', value : 'R' },
    {label : 'R1', value : 'R1' },
    {label : 'R2', value : 'R2' }
  ];

  complexteFilter : SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  ciblageParContenu : SelectItem[] = [
    {label : 'PHOTO', value : 1 },
    {label : 'SITE WEB', value : 2 },
    {label : 'LOGO', value : 3 },
    {label : 'DESCRIPTIF', value : 4},
    {label : 'RESEAUX SOCIAUX', value : 5}
  ];
  
  ciblageOp : SelectItem[] = [];

  /**
   * Filtres selectionnées
   */
  contenuSelected : any[] = [];
  complexiteSelected : any[] = [];
  opSelected : any[] = [];



  //=> gestion disabling bouton pour eviter les clicks multiples
  disabled:boolean = false;

  constructor(private echantillonageService : EchantillonageService , private encryptService:EncryptionService, private utilisateurService : UtilisateursService, private moderationService:ModerationService , private router: Router) { }

  ngOnInit(): void {
    this.getListeOp();

    this.echantillonageService.getFiltres().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let listeFiltre = value['data'];
        this.setFiltres(listeFiltre);
        let complexites = this.arrayToString(this.complexiteSelected);
        let operateurs = this.arrayToString(this.opSelected);
        
        this.echantillonageService.filtrerFiches(this.contenuSelected,complexites,operateurs).subscribe( value => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + value["cause"]);
          }else {
            this.liste = value['data'];
          }
        });
      }
    });
  }

  getComplexite(idComplexite: number) {
    switch(idComplexite) {
      case(1) : {
        return 'FAIBLE';
        break;
      }
      case(2) : {
        return 'MOYENNE';
        break;
      }
      case(3) : {
        return 'FORTE';
        break;
      }
    }
  }


  ciblerFiche(idModeration : number) {
    let op = (this.opSelected.length > 0) ? true : false;
    let contenu = (this.contenuSelected.length > 0) ? true : false;
    let complexite =(this.complexiteSelected.length > 0) ? true : false;
    this.disabled = true;
    

    this.echantillonageService.setEchantillonageSurFiche(idModeration,op,contenu,complexite).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        if(value["cause"] === "PTL déjà pris" || value["cause"] === "PTL déjà livré") {
          alert("PTL plus disponible");
          this.removeFromModerationList(idModeration);
        }
      } else {
        //alert("Fiche ciblée");
        //this.removeFromModerationList(idModeration);

        this.cqLink(idModeration, 5);
      }
    });
  }


  setFiltres(liste:any[]) {

    liste.forEach( current => {
      let valeur:string = current.valeur_filtre;
      let splitted:any[] = valeur.split(',');
      
      splitted.forEach( currentSplitted => {
        switch( parseInt(current.id_filtre)) {

          case(1) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              this.contenuSelected.push(currentSplitted);
            }
            
            break;
          }
  
          case(2) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              this.opSelected.push(currentSplitted);
            }
            
            break;
          }
  
          case(3) : {
            if(currentSplitted !== '') {
              currentSplitted = parseInt(currentSplitted);
              this.complexiteSelected.push(currentSplitted);
            }
            
            break;
          }
  
        }
      })
    });

    console.log(this.complexiteSelected)
  }

  /**
   * Les deux fonctions suivantes permettent d'enlever les lignes dans le tableau cq ou moderation
   * @param idModeration 
   */
  removeFromModerationList(idModeration : number){
    let index  = this.liste.findIndex(current => current.id_moderation === idModeration);
    this.liste = this.liste.filter((val, i) =>  i != index);
  }


  filtrerFiches() {
    let complexites = this.arrayToString(this.complexiteSelected);
    let operateurs = this.arrayToString(this.opSelected);
    let contenus = this.arrayToString(this.contenuSelected);

    this.echantillonageService.sauvegarderFiltre(contenus,complexites,operateurs).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
        alert('Problème lors du sauvegarde du filtre');
      }else {
        console.log('filtre sauvegardée');
      }
    });

    this.echantillonageService.filtrerFiches(this.contenuSelected,complexites,operateurs).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        this.liste = value['data'];
      }
    });
  }


  arrayToString(arrayIn : any[]) {
    let out = ''
    arrayIn.forEach(current => {
      out += (out === '') ? current : ',' + current;
    });
    return out;
  }


  getListeOp() {
    this.utilisateurService.getListeOp().subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let liste = value['data'];

        liste.forEach(current => {
          let currentItem = {
            label : current,
            value : current
          };
          this.ciblageOp.push(currentItem);
        });
      }

    });
  }


  /**
   * Redirection vers lien CQ
   */
  cqLink(idModeration : number,etat : number) {
    this.disabled = true;
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let options = {
      moderation : idModeration,
      operateur : user.matricule,
      action : 4,
      etat : etat
    };

    this.moderationService.changerEtat(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        if(value["cause"] === "PTL déjà pris" || value["cause"] === "PTL déjà livré") {
          alert("PTL plus disponible");
          let complexites = this.arrayToString(this.complexiteSelected);
          let operateurs = this.arrayToString(this.opSelected);
          this.echantillonageService.filtrerFiches(this.contenuSelected,complexites,operateurs).subscribe( value => {
            if(value["status"] !== "success"){
              console.log("Une erreur dans la requête:" + value["cause"]);
            }else {
              this.liste = value['data'];
              this.disabled = false;
            }
          });          
        }
      } else {
        this.router.navigate(["/cq", idModeration] );
      }
    });
  }
}
